import { useState, useEffect } from "react";

import { func_validation } from "functions";


export function useSubmission(props) {
    const {
        email, isEmailValid,
        fullName, password,
        role, referenceCode,

        selectedUserGroups,

        isUserRecordUpdatedSuccessfully
    } = props;

    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);

    function handleSubmission() {
        if (func_validation.isStringTrimNotEmpty(email) && isEmailValid &&
            func_validation.isStringTrimNotEmpty(fullName) &&
            func_validation.isStringTrimNotEmpty(password) &&

            func_validation.isStringEqual_caseInsensitive(role, "Dealer") &&
            func_validation.isStringTrimNotEmpty(referenceCode)
            // func_validation.isStringTrimNotEmpty(role) &&
            // ((!func_validation.isStringEqual_caseInsensitive(role, "Dealer") &&
            //     !func_validation.isStringEqual_caseInsensitive(role, "Sales Person")) ||
            // ((func_validation.isStringEqual_caseInsensitive(role, "Dealer") || func_validation.isStringEqual_caseInsensitive(role, "Sales Person")) && 
            //     func_validation.isStringTrimNotEmpty(referenceCode)))
            ) {

            let obj = {
                UserName: email,
                FullName: fullName,
                Password: password,
                Role: role,
                ReferenceCode: referenceCode,
            }

            let userGroups = [];
            if (func_validation.isArrayNotEmpty(selectedUserGroups)) {
                userGroups = selectedUserGroups.map((userGroup, idx) => {
                    let id = func_validation.getObjectPropertyValue(userGroup, "ID");
    
                    let obj = {};
                    obj["ID"] = 0;
                    obj["UserName"] = email;
                    obj["UserGroupId"] = id;
    
                    return obj;
                })
            }

            if (props.addUser) 
                props.addUser(obj, userGroups);
        }

        setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (isUserRecordUpdatedSuccessfully &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isUserRecordUpdatedSuccessfully]);

    return {
        handleSubmission,
        isFormSubmissionAttempted,
    }
}